export default __webpack_public_path__ + "static/media/users.c485dc8e.svg";